<template>
  <v-app>
    <v-navigation-drawer
      persistent
      fixed
      v-model="drawer"
      enable-resize-watcher
      app
      width="280"
    >
      <v-list>
        <v-list-item-group color="primary">
          <component
            v-for="(item, i) in availableTabs"
            :is="item.type"
            :key="`appbar_item_${i}`"
            v-bind="item.content"
            link
          >

            <template v-slot:activator v-if="item.type === 'v-list-group'">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </template>

            <template v-if="item.type === 'v-list-group'">
              <v-list-item link
                           v-for="subItem in item.items"
                           :key="subItem.title"
                           v-bind="subItem.content"
              >
                <v-list-item-icon>
                  <v-icon>{{ subItem.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ subItem.title }}</v-list-item-title>
              </v-list-item>
            </template>

            <v-list-item-icon v-if="item.type === 'v-list-item'">
              <v-icon v-html="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content v-if="item.type === 'v-list-item'">
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </component>

          <v-list-item @click="logout">
            <v-list-item-icon>
              <v-icon>logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="logged"></v-app-bar-nav-icon>
      <v-slide-x-transition mode="out-in">
        <v-toolbar-title :key="$store.state.title" v-text="$store.state.title"></v-toolbar-title>
      </v-slide-x-transition>
    </v-app-bar>

    <v-main>
      <v-slide-y-transition mode="out-in">
        <router-view></router-view>
      </v-slide-y-transition>
    </v-main>
  </v-app>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { mapStateTwoWay } from '@/store'
  import authService from '@/services/main'

  export default {
    data () {
      return {
        drawer: false
      }
    },

    computed: {
      ...mapState('tabs', {
        tabItems: 'items'
      }),

      ...mapGetters('acl', [
        'matchRoles',
      ]),

      ...mapStateTwoWay('tabs', [ 'activeTab' ], {
        activeTab: 'SET_ACTIVE_TAB'
      }),

      items () {
        let items = [
          {
            type: 'v-list-item',
            icon: 'home',
            title: 'Home',
            content: {
              to: {
                name: 'HelloWorld',
              },
              exact: true,
            }
          }
        ]

        items.push({
          type: 'v-list-group',
          title: 'Product Management',
          content: {
            'no-action': true,
            'prepend-icon': 'mdi-file-chart',
            'value': true
          },
          roles: ['slotting'],
          items: [
            {
              icon: 'home',
              title: 'Dashboard',
              content: {
                to: {
                  name: 'SlottingDashboard'
                }
              }
            },
            {
              icon: 'category',
              title: 'My Products',
              content: {
                to: {
                  name: 'SlottingProductOverview'
                }
              },
            },
            {
              icon: 'attach_money',
              title: 'Transactions',
              content: {
                to: {
                  name: 'SlottingTransactionOverview'
                }
              }
            },
            {
              icon: 'mdi-chart-line',
              title: 'Analytics',
              content: {
                to: {
                  name: 'SlottingReports'
                }
              }
            },
            {
              icon: 'people',
              title: 'Customers',
              roles: ['chowtaifook'],
              content: {
                to: {
                  name: 'SlottingTransactionUserOverview'
                }
              }
            },
          ]
        })
        items.push({
          type: 'v-list-item',
          icon: 'local_shipping',
          title: 'Logistics',
          content: {
            to: {
              name: 'LogisticsLocationOverview',
            },
            exact: true,
          },
          roles: ['logistics'],
        })
        let machineManagementItems = {
          type: 'v-list-group',
          title: 'Machine Management',
          content: {
            'no-action': true,
            'prepend-icon': 'mdi-file-chart',
            'value': true
          },
          roles: ['rental'],
          items: [
            {
              icon: 'home',
              title: 'Dashboard',
              content: {
                to: {
                  name: 'RentalDashboard'
                }
              }
            },
            {
              icon: 'category',
              title: 'On-shelf Products',
              content: {
                to: {
                  name: 'RentalProductOverview'
                }
              }
            },
            {
              icon: 'place',
              title: 'Locations',
              content: {
                to: {
                  name: 'RentalLocationOverview'
                }
              }
            },
            {
              icon: 'attach_money',
              title: 'Transactions',
              content: {
                to: {
                  name: 'RentalTransactionOverview'
                }
              }
            },
            {
              icon: 'mdi-chart-line',
              title: 'Analytics',
              content: {
                to: {
                  name: 'RentalReports',
                }
              }
            },
            {
              icon: 'people',
              title: 'Customers',
              roles: ['chowtaifook'],
              content: {
                to: {
                  name: 'RentalTransactionUserOverview'
                }
              }
            },
          ]
        }
        if (this.$store.state.reportType) {
          machineManagementItems.items.push({
            icon: 'mdi-file-chart',
            title: 'Monthly Reports',
            content: {
              to: {
                name: this.$store.state.reportType === 'client' ? 'RentalMonthlyReports' : 'RentalFranchiseeReports',
              }
            }
          })
        }
        items.push(machineManagementItems)

        let licenseeManagementItems = {
          type: 'v-list-group',
          title: 'Licensee Management',
          content: {
            'no-action': true,
            'prepend-icon': 'mdi-file-chart',
            'value': true
          },
          roles: ['licensor'],
          items: [
            {
              icon: 'home',
              title: 'Dashboard',
              content: {
                to: {
                  name: 'LicensorDashboard'
                }
              }
            },
            {
              icon: 'category',
              title: 'On-shelf Products',
              content: {
                to: {
                  name: 'LicensorProductOverview'
                }
              }
            },
            {
              icon: 'place',
              title: 'Locations',
              content: {
                to: {
                  name: 'LicensorLocationOverview'
                }
              }
            },
            {
              icon: 'attach_money',
              title: 'Transactions',
              content: {
                to: {
                  name: 'LicensorTransactionOverview'
                }
              }
            },
            {
              icon: 'mdi-chart-line',
              title: 'Analytics',
              content: {
                to: {
                  name: 'LicensorReports',
                }
              }
            },
            {
              icon: 'people',
              title: 'Customers',
              roles: ['chowtaifook'],
              content: {
                to: {
                  name: 'LicensorTransactionUserOverview'
                }
              }
            },
          ]
        }
        items.push({
          type: 'v-list-item',
          icon: 'mdi-account-supervisor',
          title: 'Member Management',
          content: {
            to: {
              name: 'MemberOverview',
            },
            exact: true,
          },
          roles: ['external_member_management'],
        })
        items.push(licenseeManagementItems)
        return items
      },

      // ONLY SUPPORT 2 LAYERS
      availableTabs () {
        return this.items.map(item => {
          if (item.items) {
            return {
              ...item,
              items: item.items.filter(innerItem => {
                return this.matchRoles(innerItem.roles)
              })
            }
          }

          return item
        }).filter(item => {
          return this.matchRoles(item.roles)
        })
      },

      logged () {
        return this.$store.state.token !== null
      }
    },

    created () {
      this.$store.commit('UPDATE_TITLE', '')
    },

    methods: {
      async logout () {
        this.drawer = false
        await authService.logout()
        this.$store.commit('LOGOUT')
        this.$router.push({
          path: '/login'
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Home.vue